import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaWhatsapp } from "react-icons/fa";


const Contacto = () => {
  return (
    <div id="contacto" className="contacto-container">
      
      <div className="contacto-info">
        <h3><FaWhatsapp className="icono" /> CONTACTO</h3>
        <p>
          <a
            href="https://wa.me/5215544386040?text=Hola%2C%20me%20gustaría%20más%20información%20sobre%20sus%20servicios"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", textDecoration: "none" }}
          >
            55-4438-6040
          </a>
        </p>

        <h3><FaMapMarkerAlt className="icono" /> OFICINA</h3>
        <a
          href="https://www.google.com/maps/search/?api=1&query=Av.+San+Blas+2380-2,+45615,+Tlaquepaque,+Jalisco"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "white", textDecoration: "none" }}
        >
          Av. San Blas 2380-2, 45615,<br />Tlaquepaque, JAL.
        </a>
      </div>

        <p className="mensaje-principal">
          ¿Listo para llevar tu empresa al<br />
          siguiente nivel con tecnología<br />
          inteligente?
        </p>    
      


      <div className="contacto-correo">
        
          <FaEnvelope className="icono" />{" "}
          <a href="mailto:contacto@estralabs.com"
            style={{ color: "white", textDecoration: "none" }}>
            contacto@estralabs.com
          </a>
        
      </div>


    </div>
  );
};

export default Contacto;

